"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingOverlay = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _hooks = require("../hooks");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var overlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: '#fff',
  opacity: '0.8',
  zIndex: 9999
};
var loaderStyle = {
  textAlign: 'center'
};

var DefaultLoader = function DefaultLoader(props) {
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    style: _objectSpread(_objectSpread({}, loaderStyle), props.loaderStyle)
  }, props.loaderProps, {
    "data-testid": "DefaultLoader"
  }), props.children || props.content || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border",
    variant: "primary",
    role: "status"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sr-only"
  }, "Loading...")));
};
/**
 * Example Usage: <LoadingOverlay active={loading}>Loading</LoadingOverlay>
 * @param {*} props
 */


var LoadingOverlay = function LoadingOverlay(props) {
  var overlayNode = (0, _react.useRef)(null);
  var loaderNode = (0, _react.useRef)(null);
  (0, _hooks.useNonStaticParent)(overlayNode);
  (0, _hooks.useAbsoluteCenteredPositioning)(loaderNode);
  return props.active && /*#__PURE__*/_react.default.createElement("div", _extends({
    "data-testid": "LoadingOverlay",
    ref: overlayNode,
    style: _objectSpread(_objectSpread({}, overlayStyle), props.overlayStyle)
  }, props.overlayProps), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      visibility: 'hidden'
    },
    ref: loaderNode
  }, (props.loader || DefaultLoader)(props)));
};

exports.LoadingOverlay = LoadingOverlay;